import Drawer from "@mui/material/Drawer";
import {styled} from "@mui/material/styles";

/**
 * Responsive sidenav:
 *   - xl and up   : permanent drawer (left rail, always visible)
 *   - below xl    : temporary drawer (slides in over content with a
 *                   backdrop; tap outside or press Esc to dismiss)
 *
 * The temporary/permanent variant is decided by the parent Sidenav
 * component via `useMediaQuery`; this styled wrapper just renders the
 * drawer with the appropriate width/elevation.
 */
export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints } = theme;
  const { transparentSidenav, miniSidenav } = ownerState;

  const sidebarWidth = 250;
  const { cream, transparent } = palette;
  const { xxl } = boxShadows;

  return {
    "& .MuiDrawer-paper": {
      width: sidebarWidth,
      boxShadow: xxl,
      border: "none",
      backgroundColor: transparentSidenav ? transparent.main : cream.main,

      [breakpoints.up("xl")]: {
        // Permanent rail. Width shrinks to "mini" mode when miniSidenav=true.
        width: miniSidenav ? 96 : sidebarWidth,
        overflowX: "hidden",
        transition: transitions.create(["width"], {
          easing: transitions.easing.sharp,
          duration: transitions.duration.enteringScreen,
        }),
      },
    },
  };
});
